// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"1802b376","513":"b092277f","787":"d6c18a7b"}[chunkId] + ".chunk.js";
};